export default __webpack_public_path__ + "device_mobility_car_cam.50b6b34a.png";